<template>
  <div>
    <div class="navBar">
      <span @click="leftClick()">取消</span>
      <span>新增笔记</span>
      <span @click="rightClick()">发布</span>
    </div>
    <van-field
      v-model="message"
      rows="10"
      autosize
      type="textarea"
      maxlength="500"
      style="padding: 0 2px;"
      placeholder="输入您的笔记内容，限500字以内"
      show-word-limit
      @input="onInput"
    />
  </div>
</template>

<script>
import { Field, Toast } from "vant";
import api from "@/api/index";
export default {
  components: {
    [Field.name]: Field,
    [Toast.name]: Toast,
  },
  data() {
    return {
      message: "",
      userId: "",
    };
  },
  methods: {
    leftClick() {
      this.$router.go(-1);
    },
    onInput() {
      // console.log(this.message.length);
    },
    rightClick() {
      this.userId = localStorage.getItem("userId");
      // console.log(this.message);
      let params = {
        accountId: this.userId,
        content: this.message,
      };
      api.getTradeAddNote(params).then((res) => {
        // console.log(res);
        if (res.code == 200) {
          Toast("发布成功");
          this.$router.go(-1);
        } else {
          Toast(res.message);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.navBar {
  height: 0.88rem;
  padding: 0 0.32rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.32rem;
  color: #333333;
}
/deep/.van-field__word-limit{
  padding-right: 0.2rem;
}
</style>